module.exports = __webpack_public_path__ + "static/media/buy-plan.6749daa4.png";